var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "regular_water",
    transform: "matrix(0.3125,0,0,0.16,-335.625,729.352)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 0,
    width: 1024,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2,0,0,6.25,946,-3694.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,900.123C189.01,888.047 104.461,814.895 100,707.123C95.539,599.352 200,602.123 200,602.123C200,602.123 304.461,599.228 300,707C295.539,814.772 210.99,887.923 200,900L200,900.123Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-43.6822,40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 243.682,
    cy: 660,
    r: 49.681,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c8064bb42638b32c4ffe9b291733bd83.svg";
export { ForwardRef as ReactComponent };